import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import { wordpressImgToImgixURL } from 'Utilities';
import { GA_TAGS } from 'Utilities/analytics';

import styles from './RelatedGuides.scss';

type Thumbnail = {
  alt?: string;
  url: string;
};

type RelatedGuidesProps = {
  description?: string | null;
  largeTheme?: boolean;
  thumbnail?: string | Thumbnail | null;
  title?: string | null;
  url: string;
}

const RelatedGuides = ({
  description = null,
  largeTheme = false,
  thumbnail = null,
  title = null,
  url,
}: RelatedGuidesProps) => {
  const isString = typeof thumbnail === 'string';
  const imgixWidth = largeTheme ? 448 : 288;

  return (
    <div className={cx(styles.relatedGuidesInnerContainer, { [styles.largeTheme]: largeTheme })}>
      <Link
        onClick={() => GA_TAGS.LANDINGPAGES_RELATED_CAR_GUIDE_CLICKED(title)}
        to={url}
      >
        <div className={styles.thumbnailContainer}>
          {(thumbnail) ? (
            <img
              alt={isString ? '' : thumbnail.alt}
              height="192"
              loading="lazy"
              src={`${wordpressImgToImgixURL(isString ? thumbnail : thumbnail.url)}&w=${imgixWidth}`}
              width="288"
            />
          ) : (null)}
        </div>
        <div className={styles.textContent}>
          <h5 className={styles.title}>{title}</h5>
          <p className={styles.description}>{description}</p>
        </div>
      </Link>
    </div>
  );
};

export default RelatedGuides;
